import styled from 'styled-components'

export const Value = styled.p`
  font-size: 1.4rem;
  line-height: 1.68rem;
`
